var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "收款详情",
        visible: _vm.visible,
        width: "600px",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "payment-detail-wrap",
        },
        [
          _c("div", { staticClass: "info-section" }, [
            _c("div", { staticClass: "info-row" }, [
              _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("商家类型：")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.merchantTypeText(_vm.detail.merchantType))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("商家名称：")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.detail.merchantName || "-")),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-row" }, [
              _c("div", { staticClass: "info-item info-item-full" }, [
                _c("span", { staticClass: "label" }, [_vm._v("对账周期：")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.detail.periodDesc || "-")),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "deduction-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _c("span", { staticClass: "title-text" }, [_vm._v("抵扣明细")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "deduction-list" }, [
              _c("div", { staticClass: "deduction-item" }, [
                _c("span", { staticClass: "deduction-label" }, [
                  _vm._v("订单金额："),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "deduction-value income" }, [
                  _vm._v(
                    "+￥" + _vm._s(_vm.formatAmount(_vm.detail.productAmount))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "deduction-item" }, [
                _c("span", { staticClass: "deduction-label" }, [
                  _vm._v("订单数量："),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "deduction-value" }, [
                  _vm._v(_vm._s(_vm.detail.orderCount || 0)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "deduction-item" }, [
                _c("span", { staticClass: "deduction-label" }, [
                  _vm._v("福豆总抵扣："),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "deduction-value expense" }, [
                  _vm._v(
                    "-￥" + _vm._s(_vm.formatAmount(_vm.detail.fuDouDeduction))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "deduction-item" }, [
                _c("span", { staticClass: "deduction-label" }, [
                  _vm._v("积分抵扣："),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "deduction-value expense" }, [
                  _vm._v(
                    "-￥" +
                      _vm._s(_vm.formatAmount(_vm.detail.integralDeduction))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "deduction-item" }, [
                _c("span", { staticClass: "deduction-label" }, [
                  _vm._v("优惠券优惠："),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "deduction-value expense" }, [
                  _vm._v(
                    "-￥" + _vm._s(_vm.formatAmount(_vm.detail.couponDiscount))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "deduction-item" }, [
                _c("span", { staticClass: "deduction-label" }, [
                  _vm._v("第三方支付抵扣："),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "deduction-value expense" }, [
                  _vm._v(
                    "-￥" +
                      _vm._s(_vm.formatAmount(_vm.detail.thirdPartyDeduction))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "deduction-item" }, [
                _c("span", { staticClass: "deduction-label" }, [
                  _vm._v("损失金额："),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "deduction-value expense" }, [
                  _vm._v(
                    "-￥" + _vm._s(_vm.formatAmount(_vm.detail.lossAmount))
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fucard-section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _c("span", { staticClass: "title-text" }, [
                  _vm._v("福卡抵扣明细"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "fucard-table",
                  attrs: {
                    data: _vm.detail.fuCardDeductionList,
                    size: "mini",
                    border: "",
                    "header-cell-style": {
                      background: "#f5f7fa",
                      color: "#606266",
                      fontWeight: "bold",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "fuCardName",
                      label: "福卡名称",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "实际总抵扣",
                      "min-width": "150",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "expense" }, [
                              _vm._v(
                                "-￥" +
                                  _vm._s(
                                    _vm.formatAmount(
                                      scope.row.actualTotalDeduction
                                    )
                                  )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.detail.fuCardDeductionList ||
              _vm.detail.fuCardDeductionList.length === 0
                ? _c("div", { staticClass: "fucard-empty" }, [
                    _vm._v("\n        暂无福卡抵扣数据\n      "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关 闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }